var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.203,
    height: 24.967,
    viewBox: "0 0 26.203 24.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M12.088,1.5C5.423,1.5,0,6.38,0,12.379a10.058,10.058,0,0,0,1.921,5.884c-.238,2.634-.876,4.589-1.8,5.516a.4.4,0,0,0,.285.688.383.383,0,0,0,.056,0,21.539,21.539,0,0,0,6.7-2.151,13.118,13.118,0,0,0,4.933.946c6.665,0,12.088-4.88,12.088-10.879S18.753,1.5,12.088,1.5Z",
    transform: "translate(1.027 -0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.1d62572597686d6481f2a0cb2b5b951f.svg";
export { ForwardRef as ReactComponent };